import React from 'react'
import { appConfig } from '../config.js';
import { Table } from 'semantic-ui-react';


const CoverageCompare = ({ proc, profile, sites }) => {
    console.log(sites);
    return (
        <div>
            <Table id='table-sites' celled inverted selectable size='small'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Site Name</Table.HeaderCell>
                        <Table.HeaderCell>Total population covered</Table.HeaderCell>
                        <Table.HeaderCell>Population already covered</Table.HeaderCell>
                        <Table.HeaderCell>Population not previously covered</Table.HeaderCell>
                        <Table.HeaderCell>Population better covered</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>

                    {sites.map(site =>
                        <Table.Row key={`${site.pk}`}>
                            <Table.Cell
                                data-tooltip={`Site: ${site.name} (version: ${site.version_number})`}
                                data-inverted=""
                            >
                                {site.name}
                            </Table.Cell>
                            <Table.Cell
                                data-tooltip={`Total Population Covered`}
                                data-inverted=""
                            >
                                {site.cc_total_pop_covered}
                            </Table.Cell>
                            <Table.Cell
                                data-tooltip={`Population already covered with existing infrastructure`}
                                data-inverted=""
                            >
                                {site.cc_pop_already_covered}
                            </Table.Cell>
                            <Table.Cell
                                data-tooltip={`Population not previously covered with existing infrastructure`}
                                data-inverted=""
                            >
                                {site.cc_pop_not_previously_covered}
                            </Table.Cell>
                            <Table.Cell
                                data-tooltip={`Population better covered`}
                                data-inverted=""
                            >
                                {site.cc_pop_better_covered}
                            </Table.Cell>
                        </Table.Row>
                        )
                    }

                </Table.Body>
            </Table>

            <a href={`${appConfig.api.URL}/coveragecompare/${proc.collection_version.pk}/csv`}>
                <button className="ui icon button large"
                    data-tooltip="Download CSV"
                    data-inverted=""
                >
                    <i aria-hidden="true" className="download icon"></i>
                </button>
            </a>
        </div>
    )
}

export default CoverageCompare;
